jQuery( '.topImage' ).slick( {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  autoplay: false,
  rows: 0,
  asNavFor: '.topImageNav'
} );
jQuery( '.topImageNav' ).slick( {
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.topImage',
  autoplay: false,
  dots: false,
  fade: false,
  arrows: true,
  centerMode: true,
  rows: 0,
  centerPadding: '0',
  prevArrow: `<button aria-label="Prev slider" class="arrow-button slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.95" height="11.171" viewBox="0 0 17.95 11.171" style="transform:scaleX(-1)"><g fill="currentColor"><path d="M16.534 6.52H0v-2h16.534Z"></path><path d="m12.363 11.171-1.414-1.414 4.172-4.171-4.172-4.171L12.363.001l5.587 5.586Z"></path></g></svg></button>;`,
  nextArrow: `<button aria-label="Next slider" class="arrow-button slick-arrow slick-next"><svg svg xmlns="http://www.w3.org/2000/svg" width="17.95" height="11.171" viewBox="0 0 17.95 11.171" ><g fill="currentColor"><path d="M16.534 6.52H0v-2h16.534Z"></path><path d="m12.363 11.171-1.414-1.414 4.172-4.171-4.172-4.171L12.363.001l5.587 5.586Z"></path></g></svg></button >;`
} );